import { useQuery } from '@tanstack/react-query';
import {
  searchWaterfallExecutions,
  searchVoxOrderHistory,
  getWaterfallExecutionDetail,
  getVoxOrderHistoryDetail,
  getVendorCapabilities,
} from '../services/voxTracingService';
import {
  WaterfallExecutionSearchRequest,
  WaterfallExecutionSearchResponse,
  WaterfallExecutionDetailResponse,
  VoxOrderHistorySearchRequest,
  VoxOrderHistorySearchResponse,
  VoxOrderHistoryDetailResponse,
  VendorCapabilityInfo,
} from '../models/voxTracing';

export const useWaterfallExecutionSearch = (
  params: WaterfallExecutionSearchRequest,
  enabled: boolean = false
) => {
  const searchQuery = useQuery<WaterfallExecutionSearchResponse[]>({
    queryKey: ['waterfall-execution-search', params],
    queryFn: () => searchWaterfallExecutions(params),
    enabled,
    staleTime: 10_000,
    refetchOnWindowFocus: false,
  });

  return { searchQuery };
};

export const useVoxOrderHistorySearch = (
  params: VoxOrderHistorySearchRequest,
  enabled: boolean = false
) => {
  const searchQuery = useQuery<VoxOrderHistorySearchResponse[]>({
    queryKey: ['vox-order-history-search', params],
    queryFn: () => searchVoxOrderHistory(params),
    enabled,
    staleTime: 10_000,
    refetchOnWindowFocus: false,
  });

  return { searchQuery };
};

export const useWaterfallExecutionDetail = (guid?: string) => {
  const detailQuery = useQuery<WaterfallExecutionDetailResponse>({
    queryKey: ['waterfall-execution-detail', guid],
    queryFn: () => getWaterfallExecutionDetail(guid!),
    enabled: !!guid,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

  return { detailQuery };
};

export const useVoxOrderHistoryDetail = (guid?: string) => {
  const detailQuery = useQuery<VoxOrderHistoryDetailResponse>({
    queryKey: ['vox-order-history-detail', guid],
    queryFn: () => getVoxOrderHistoryDetail(guid!),
    enabled: !!guid,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

  return { detailQuery };
};

export const useVendorCapabilities = (vendor?: string) => {
  const capabilitiesQuery = useQuery<VendorCapabilityInfo>({
    queryKey: ['vendor-capabilities', vendor],
    queryFn: () => getVendorCapabilities(vendor!),
    enabled: !!vendor,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

  return { capabilitiesQuery };
};
